
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Login } from './Components/Login/Components/Login';
import { RecuperarPwd } from './Components/Login/Components/RecuperarPwd';
import { UserCard } from './Components/Login/Components/UserCardComponent';
import { Dashboard } from './Components/Dashboard/Components/DashboardComponents';
import { Header } from './Components/Dashboard/Components/HeaderComponent';
import { Footer } from './Components/Dashboard/Components/FooterComponenet';
import { Torneos } from './Components/Dashboard/Components/CardTorneoComponents';
import '@fortawesome/fontawesome-free/css/all.min.css';
import usuarios from './assets/usuarios.jpg';
import { CardEquipos } from './Components/Dashboard/Components/CardEquipos';
import { CardUsuarios } from './Components/Dashboard/Components/CardUsuariosComponent';
import { CardParticipantes } from './Components/Dashboard/Components/CardParticipanteComponent';
import { CardPartidos } from './Components/Dashboard/Components/CardPartidosComponent';
import EstadisticasTorneo from './Components/Dashboard/Components/EstadisticasTorneoComponent';
import { CardEscenarios } from './Components/Dashboard/Components/CardEscenariosComponent';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './Components/PrivateRoute';
import { Navigate } from 'react-router-dom';
import { CardPartidosLogout } from './Components/Dashboard/Components/CardPartidosLogoutComponent';
import { DashboardLogout } from './Components/Dashboard/Components/DashboardLogoutComponent';
import ImagenesTorneoComponet from './Components/Dashboard/Components/ModalimagenesEventoComponent';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <Header username={"David Lozada"} userImage={usuarios} /> {/* Header */}
          <main className="main-content">
            <Routes>
              {/* <Route path="/" element={<Dashboard />} /> */}

              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              
              <Route path="/torneos" element={<Torneos />} />
              <Route
                path="/equipos"
                element={
                  <PrivateRoute>
                    <CardEquipos />
                  </PrivateRoute>
                }
              />
              <Route path="/usuarios" element={<CardUsuarios />} />
              <Route path="/participantes" element={<CardParticipantes />} />
              {/* <Route path="/planillar" element={<CardParticipantes />} />
            <Route path="/estadisticas" element={<CardParticipantes />} /> */}
              <Route path="/partidos/:idTorneo" element={<CardPartidos />} />
              <Route path="/partidoslogout/:idTorneo" element={<CardPartidosLogout />} />
              <Route path="/imagenes" element={<ImagenesTorneoComponet />} />






              <Route
                path="/escenarios"
                element={
                  <PrivateRoute>
                    <CardEscenarios />
                  </PrivateRoute>
                }
              />
              <Route path="/estadisticas/:id/:nombre" element={<EstadisticasTorneo />} />


              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<RecuperarPwd />} />
              <Route path="/dashboardlogout" element={<DashboardLogout />} />

              <Route path="*" element={<Navigate to="/dashboard" />} /></Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
